<ngx-muvstok></ngx-muvstok>
<router-outlet></router-outlet>